import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Link } from '@material-ui/core';

const PublicShareErrorMessage: FC = () => {
  const { t } = useTranslation();

  function renderErrorLink() {
    return (
      <Link color="error" href={window.location.href}>
        {t('sharing:publicShareErrorLink')}
      </Link>
    );
  }

  return (
    // the extra single quotes below are necessary for the link to render properly
    <Trans i18nKey="'sharing:publicShareError'">
      ✋ &nbsp;Oh no, there was a problem sending your share!&nbsp;
      {renderErrorLink()} and try again.
    </Trans>
  );
};

export default PublicShareErrorMessage;
